import { Component, ViewChild } from '@angular/core';

import { NavController, Slides } from 'ionic-angular';
import { ServiceProvider } from '../../providers/ServiceProvider';
import { AtlasHomePage } from '../atlas/AtlasHome/AtlasHome';
import { AcademyHomePage } from '../academy/AcademyHome/AcademyHome';
import { ChilanHomePage } from '../chilan/ChilanHome/ChilanHome';
import { SessionProvider } from '../../providers/SessionProvider';
import { LoginProvider } from '../../providers/LoginProvider';


@Component({
    selector: 'page-home',
    templateUrl: 'home.html'
})
export class HomePage {
    public Sliders: any = [];
    public SliderOptions: any;
    constructor(public navCtrl: NavController, public serviceProvider: ServiceProvider, public sessionProvider: SessionProvider, public loginProvider: LoginProvider) {
    }
    ionViewWillEnter() {
        console.log("view entered");
        this.loadSliders();
    }
    loadSliders() {
        //clear Sliders
        this.Sliders.splice(0, this.Sliders.length);
        this.serviceProvider.Get("ISPA_Slider", false).then((result) => {
            let sliders: any;
            sliders = result;
            sliders.forEach((value, index) => {
                let gift = value;

                this.Sliders.push(gift);
            });
        });
    }
    a_atlasClick() {
        this.navCtrl.push(AtlasHomePage);
    }
    a_academyClick() {
        this.navCtrl.push(AcademyHomePage);
    }
    a_chilanClick() {
        this.navCtrl.push(ChilanHomePage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts